/* Fragrance product page motion (fx-*)
   Framer-style motion in plain JS: spring easing lives in CSS, this file
   only decides *when* things change. Respects prefers-reduced-motion. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- Story: words light up as you scroll through them ---------- */
  function splitWords(el) {
    var walk = function (node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var parts = child.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) {
              frag.appendChild(document.createTextNode(part));
            } else {
              var span = document.createElement('span');
              span.className = 'fx-w';
              span.textContent = part;
              frag.appendChild(span);
            }
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') {
          walk(child);
        }
      });
    };
    walk(el);
    return Array.prototype.slice.call(el.querySelectorAll('.fx-w'));
  }

  var wordItems = [];
  var wordTicking = false;

  function updateWords() {
    wordTicking = false;
    var vh = window.innerHeight;
    wordItems.forEach(function (item) {
      var rect = item.el.getBoundingClientRect();
      var start = vh * 0.88;
      var end = vh * 0.4;
      var total = start - end + rect.height;
      var progress = Math.min(1, Math.max(0, (start - rect.top) / total));
      var lit = Math.round(progress * item.words.length);
      if (lit === item.lit) return;
      var from = Math.min(lit, item.lit < 0 ? 0 : item.lit);
      var to = Math.max(lit, item.lit < 0 ? item.words.length : item.lit);
      for (var i = from; i < to; i++) {
        item.words[i].classList.toggle('is-lit', i < lit);
      }
      item.lit = lit;
    });
  }

  function onWordScroll() {
    if (!wordTicking) {
      wordTicking = true;
      window.requestAnimationFrame(updateWords);
    }
  }

  function initWords(root) {
    if (reduceMotion.matches) return;
    root.querySelectorAll('[data-fx-words]').forEach(function (el) {
      if (el.dataset.fxInit) return;
      el.dataset.fxInit = '1';
      wordItems.push({ el: el, words: splitWords(el), lit: -1 });
      el.classList.add('fx-words-ready');
    });
    if (wordItems.length && !initWords.bound) {
      initWords.bound = true;
      window.addEventListener('scroll', onWordScroll, { passive: true });
      window.addEventListener('resize', onWordScroll);
    }
    updateWords();
  }

  /* ---------- How it wears: stage follows the note tier in view ---------- */
  function initDrydown(root) {
    root.querySelectorAll('[data-fx-drydown]').forEach(function (section) {
      if (section.dataset.fxInit) return;
      section.dataset.fxInit = '1';
      var tiers = Array.prototype.slice.call(section.querySelectorAll('[data-fx-tier]'));
      if (!tiers.length) return;

      var setStage = function (tier) {
        tiers.forEach(function (t) {
          t.classList.toggle('is-active', t === tier);
        });
        section.dataset.stage = tier.dataset.fxTier;
      };

      setStage(tiers[0]);
      if (!hasIO) return;
      section.classList.add('fx-ready');

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setStage(entry.target);
          });
        },
        { rootMargin: '-45% 0px -45% 0px' }
      );
      tiers.forEach(function (t) {
        observer.observe(t);
      });
    });
  }

  /* ---------- One-time reveal (accord bars) ---------- */
  function initReveal(root) {
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-fx-reveal]')).filter(function (el) {
      return !el.dataset.fxInit;
    });
    els.forEach(function (el) {
      el.dataset.fxInit = '1';
    });
    if (reduceMotion.matches || !hasIO) {
      els.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );
    els.forEach(function (el) {
      el.classList.add('fx-ready');
      observer.observe(el);
    });
  }

  /* ---------- FAQ: smooth open and close ---------- */
  function initAccordions(root) {
    root.querySelectorAll('[data-fx-accordion] details').forEach(function (details) {
      if (details.dataset.fxInit) return;
      details.dataset.fxInit = '1';
      var summary = details.querySelector('summary');
      var body = details.querySelector('.fx-faq__answer');
      if (!summary || !body || !body.animate) return;
      var anim = null;
      var ease = 'cubic-bezier(0.22, 1, 0.36, 1)';

      summary.addEventListener('click', function (event) {
        if (reduceMotion.matches) return;
        event.preventDefault();
        if (anim) anim.cancel();

        if (!details.open) {
          details.open = true;
          var openHeight = body.offsetHeight;
          anim = body.animate(
            [
              { height: '0px', opacity: 0 },
              { height: openHeight + 'px', opacity: 1 },
            ],
            { duration: 450, easing: ease }
          );
          anim.onfinish = function () {
            anim = null;
          };
        } else {
          var closeHeight = body.offsetHeight;
          anim = body.animate(
            [
              { height: closeHeight + 'px', opacity: 1 },
              { height: '0px', opacity: 0 },
            ],
            { duration: 320, easing: ease }
          );
          anim.onfinish = function () {
            details.open = false;
            anim = null;
          };
        }
      });
    });
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-fx-sticky]');
    if (!bar || bar.dataset.fxInit) return;
    bar.dataset.fxInit = '1';

    var info = document.querySelector('product-info[id^="MainProduct-"]');
    var mainBtn = info && info.querySelector('button[name="add"]');
    if (!mainBtn || !hasIO) {
      bar.remove();
      return;
    }

    var btn = bar.querySelector('[data-fx-sticky-btn]');
    var priceEl = bar.querySelector('[data-fx-sticky-price]');
    var visible = false;

    var sync = function () {
      var current = info.querySelector('button[name="add"]') || mainBtn;
      mainBtn = current;
      var label = current.querySelector('span');
      var text = (label ? label.textContent : current.textContent).trim();
      if (text) btn.textContent = text;
      btn.disabled = current.disabled;

      var price = info.querySelector('.price');
      if (price && priceEl) {
        var onSale = price.classList.contains('price--on-sale');
        var item = price.querySelector(onSale ? '.price-item--sale' : '.price__regular .price-item--regular');
        if (item && item.textContent.trim()) priceEl.textContent = item.textContent.trim();
      }
    };

    var syncQueued = false;
    new MutationObserver(function () {
      if (syncQueued) return;
      syncQueued = true;
      window.requestAnimationFrame(function () {
        syncQueued = false;
        sync();
      });
    }).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });

    var setVisible = function (next) {
      if (next === visible) return;
      visible = next;
      bar.classList.toggle('is-visible', next);
      bar.inert = !next;
      bar.setAttribute('aria-hidden', String(!next));
    };

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(mainBtn);

    btn.addEventListener('click', function () {
      var current = info.querySelector('button[name="add"]');
      if (current && !current.disabled) current.click();
    });

    bar.inert = true;
    sync();
  }

  function initAll(root) {
    root = root || document;
    initWords(root);
    initDrydown(root);
    initReveal(root);
    initAccordions(root);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
